import { render } from "./SubMenu.vue?vue&type=template&id=6ee53f08&ts=true"
import script from "./SubMenu.vue?vue&type=script&lang=ts"
export * from "./SubMenu.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__